import OpTextButton from "../../components/OpTextButton";
import {
  approveWithDrawApprovalSetting,
  rejectWithDrawApprovalSetting,
} from "../../api/signer";
import {
  useAlerting,
  usePermission,
  useTabs,
  useTranslation,
  useYubiPrompt,
} from "../../hooks";
import { displayAmount, getDecimal, jsonParse } from "../../utils/helper";
import { customSx } from "../../utils/styling";
import {
  useZusDialogStore,
  useWithDrawApprovalSettingStore,
  zusRefetchStore,
  useZusTabsStore,
} from "../../zustand/store";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "../MuiGenerals";
import { FeatureCodes, enumAdjustmentStatus } from "../../utils/constant";
import React, { useState } from "react";
import style from "./regulationDialogCss.module.css";
import MpTextField from "../MpTextField";
import { useAppSelector } from "../../reducer/hooks";
import { selectProfile } from "../../reducer/profileSlice";
import YubiPrompter from "../Prompter";

import GeneralBtn from "../GeneralBtn";
import { IWithdrawApprovalRegulationRequest } from "src/zustand/types";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PendingCount from "src/components/PendingCount";
import { OperationType } from "@wallet-manager/node-types/dist/src/postgres/const";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const translatePrefix = "withdrawApprovalSetting";
const Pkey = FeatureCodes.assetManagement.WithdrawApprovalSetting.TabRecord;
const ApproveOrRejectDialog = () => {
  const { alerting } = useAlerting();
  const { email } = useAppSelector(selectProfile);
  //{- - translation- -}
  const { t, translate } = useTranslation(translatePrefix);
  const configTime = useWithDrawApprovalSettingStore(
    (state) => state.configTime,
  );
  //{- -Reduxt Tools - -}
  const { hasPermission } = usePermission();
  const { getResAfterYubi, prompterConfig } = useYubiPrompt();

  //{- - Zustand Tools- -}
  const refetFunc = zusRefetchStore((state) => state.refetchFunc);

  const zusDialog = useZusDialogStore();
  const useStore = useWithDrawApprovalSettingStore((state) => state);
  const recordWatch = useStore.recordWatch;
  /* separate two array from a single array by wallet_type,  */
  const withdrawArr = recordWatch.withdraw_approval_regulation_requests?.filter(
    (item) =>
      item.operation_type == OperationType.Withdraw && !item.wallet_type,
  );
  const settleMemetwArr =
    recordWatch.withdraw_approval_regulation_requests?.filter(
      (item) =>
        item.operation_type == OperationType.Withdraw && item.wallet_type,
    );
  const swapArr: IWithdrawApprovalRegulationRequest[] =
    recordWatch.withdraw_approval_regulation_requests?.filter(
      (item) => item.operation_type == OperationType.Swap,
    );
  // {- - - - Params for send to backend- - - - -}
  const params = {
    id: recordWatch.id ? Number(recordWatch.id) : "",
  };
  //
  //{- - - -handle confirm - - - -}
  const onApprove = async () => {
    const isCreator = recordWatch.created_by === email;
    if (!hasPermission(Pkey.ApproveRecord)) {
      return alerting("error", t("alert_no_approval_permission"));
    }
    if (isCreator) {
      return alerting("error", t("alert_creator_approver_same"));
    }
    const resp = await getResAfterYubi(approveWithDrawApprovalSetting, params);

    if (resp) {
      alerting("success", t("ConfirmApprove"));
      refetFunc({ where: "withdrawSettingReordTab" });
      zusDialog.closeAll();
    }
  };
  //{- -handle Reject  - -}
  const onReject = async () => {
    if (!hasPermission(Pkey.RejectRecord)) {
      return alerting("error", t("alert_no_approval_permission"));
    }
    const resp = await getResAfterYubi(rejectWithDrawApprovalSetting, params);

    if (resp) {
      alerting("success", t("ConfirmReject"));
      refetFunc({ where: "withdrawSettingReordTab" });
      zusDialog.closeAll();
    }
  };
  //{- - - -Debug - - - -}
  const pendingStatus = translate(
    `enumWithDrawApprovalSetting.${enumAdjustmentStatus[0].toLowerCase()}`,
  );
  const isPendingStatus = recordWatch.status == pendingStatus;

  return (
    <>
      <YubiPrompter {...prompterConfig} />
      <Dialog
        open={zusDialog.match("approvalDialog")}
        onClose={zusDialog.close}
        fullWidth={true}
        PaperProps={{ sx: { maxWidth: "700px" } }}
      >
        <DialogTitle>{t("withDrawApprovalSettingDialog")}</DialogTitle>
        <DialogContent>
          <MpTextField
            variant="filled"
            defaultValue={recordWatch?.chain_name}
            fullWidth={true}
            label={t("chain_name")}
            disabled={true}
          />
          <br />
          <MpTextField
            variant="filled"
            defaultValue={recordWatch?.asset_name}
            fullWidth={true}
            label={t("chain_asset")}
            disabled={true}
          />
          {/* Divide Line */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ fontSize: "12px", minWidth: "170px" }}>
                {t("before_amt")}
              </div>
              <div style={{ fontSize: "12px", minWidth: "170px" }}>
                {t("after_amt")}
              </div>
            </div>
          </div>
          <HorizotalDiplayFormat
            beforeAmt={recordWatch?.existing_hourly_auto_approval_limit}
            afterAmt={recordWatch?.hourly_auto_approval_limit}
            labelName={t("max_hourly_approve_limit", configTime)}
          />
          <HorizotalDiplayFormat
            beforeAmt={recordWatch?.existing_mx_hourly_limit}
            afterAmt={recordWatch.reqEditMaxNoTrxAmt}
            labelName={t("mx_hourly_limit", configTime)}
          />
          <HorizotalDiplayFormat
            beforeAmt={recordWatch?.existing_to_addr_hourly_limit}
            afterAmt={recordWatch?.reqEditMaxLimitWithin1Hr}
            labelName={t("mx_addr_hrly_limit", configTime)}
          />

          <HorizotalDiplayFormat
            beforeAmt={recordWatch?.existing_to_addr_hourly_count}
            afterAmt={recordWatch.reqEditMaxNoTrxs}
            labelName={t("mx_addr_hrly_count", configTime)}
          />
          <br />
          {/*  */}
          <div style={{ fontWeight: "bold", marginBottom: "1rem" }}>
            {t("regulation")}
          </div>
          <ApprovalRegulation
            withdrawArr={withdrawArr}
            settleMemetwArr={settleMemetwArr}
            swapArr={swapArr}
          />
        </DialogContent>
        <DialogActions sx={customSx.dialogBtnMargin}>
          <GeneralBtn
            label="approve"
            isHidden={
              !(
                isPendingStatus &&
                (hasPermission(Pkey.ApproveRecord) ||
                  hasPermission(Pkey.RejectRecord))
              )
            }
            onClick={onApprove}
          />
          <GeneralBtn
            label="reject"
            isHidden={
              !(
                isPendingStatus &&
                (hasPermission(Pkey.ApproveRecord) ||
                  hasPermission(Pkey.RejectRecord))
              )
            }
            onClick={onReject}
          />
          <GeneralBtn label="cancel" color="error" onClick={zusDialog.close} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ApproveOrRejectDialog);

const HorizotalDiplayFormat = (props: {
  beforeAmt: string;
  afterAmt: string;
  labelName: string;
  row?: any;
}) => {
  const { beforeAmt, afterAmt, labelName } = props;
  return (
    <section
      // key={item.id}
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <div
        style={{
          minWidth: "200px",
          maxWidth: "200px",
          fontSize: "11px",
          whiteSpace: "pre-wrap",
          alignSelf: "center",
        }}
      >
        {labelName}
      </div>
      <MpTextField
        name={"before_amt"}
        variant="filled"
        defaultValue={beforeAmt}
        sx={{
          textAlign: "center",
          marginRight: "1.5px",
          "& .MuiInputBase-input": {
            minHeight: "35px",
            minWidth: "150px",
            transform: "translateY(-9px)",
          },
        }}
        disabled={true}
      />
      <MpTextField
        name={"after_amt"}
        variant="filled"
        defaultValue={afterAmt}
        sx={{
          marginLeft: "1.5px",
          "& .MuiInputBase-input": {
            minHeight: "35px",
            minWidth: "150px",
            transform: "translateY(-9px)",
          },
        }}
        disabled={true}
      />
    </section>
  );
};

export const mergeArrays = (firstArr: Array<any>, secondArr: Array<any>) => {
  // Concatenate the two arrays
  const withdrawArrWithNewFieldNames = firstArr.map((item: any) => {
    const newObj = { ...item };
    newObj["withdraw_request_amt"] = newObj["amount"];
    newObj["withdraw_existing_amt"] = newObj["existing_amount"];
    delete newObj["amount"];
    delete newObj["existing_amount"];
    delete newObj["wallet_type"];
    return newObj;
  });
  const settleArrWithNewFieldNames = secondArr.map((item: any) => {
    const newObj = { ...item };
    newObj["settle_request_amt"] = newObj["amount"];
    newObj["settle_existing_amt"] = newObj["existing_amount"];
    delete newObj["amount"];
    delete newObj["existing_amount"];
    delete newObj["wallet_type"];
    return newObj;
  });
  const mergedArr = withdrawArrWithNewFieldNames.concat(
    settleArrWithNewFieldNames,
  );

  const mergedMap = new Map();
  mergedArr.forEach((element: any) => {
    // Get the seq property
    const seq = element.seq;
    // Check if this seq is already in the map
    if (mergedMap.has(seq)) {
      // If it is, merge the current object with the existing one
      const existingObj = mergedMap.get(seq);
      const mergedObj = {
        id: element.id || existingObj.id,
        seq: seq,
        withdraw_request_amt:
          element.withdraw_request_amt || existingObj.withdraw_request_amt,
        withdraw_existing_amt:
          element.withdraw_existing_amt || existingObj.withdraw_existing_amt,
        settle_request_amt:
          element.settle_request_amt || existingObj.settle_request_amt,
        settle_existing_amt:
          element.settle_existing_amt || existingObj.settle_existing_amt,
        withdraw_approval_regulation_request_fk:
          element.withdraw_approval_regulation_request_fk ||
          existingObj.withdraw_approval_regulation_request_fk,
        withdraw_threshold_request_id:
          element.withdraw_threshold_request_id ||
          existingObj.withdraw_threshold_request_id,
      };
      mergedMap.set(seq, mergedObj);
    } else {
      // If it's not, add the current object to the map
      mergedMap.set(seq, element);
    }
  });
  // Convert the map back to an array and return it
  const mergedArrWithNoDuplicates = Array.from(mergedMap.values());

  return mergedArrWithNoDuplicates ? mergedArrWithNoDuplicates : [];
};

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index} //hidden all if no index==value
      id={`simple-tabpanel-${index}`} //showing which tab
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ApprovalRegulation = (props: {
  withdrawArr: IWithdrawApprovalRegulationRequest[];
  settleMemetwArr: IWithdrawApprovalRegulationRequest[];
  swapArr: IWithdrawApprovalRegulationRequest[];
}) => {
  const { t } = useTranslation(translatePrefix);
  const { withdrawArr, settleMemetwArr, swapArr } = props;
  const [tabsIndex, setTabsIndex] = useState(0);
  const zusTabsStore = useZusTabsStore((state) => state);
  const destinationTabs = [
    {
      name: "external_withdraw",
      arr: withdrawArr,
      countDom: <PendingCount count={withdrawArr.length} />,
    },
    {
      name: "internal_withdraw",
      arr: settleMemetwArr,
      countDom: <PendingCount count={settleMemetwArr.length} />,
    },
    {
      name: "swap",
      arr: swapArr,
      countDom: <PendingCount count={swapArr.length} />,
    },
  ];
  const useStore = useWithDrawApprovalSettingStore((state) => state);
  const recordWatch = useStore.recordWatch;

  const handleTabChange = (event: React.SyntheticEvent, tabsEnum: number) => {
    zusTabsStore.setGridTabsEumn(0);
    setTabsIndex(tabsEnum);
  };

  const getProperValues = (value: string) => {
    const decimal = getDecimal(recordWatch);
    const properAmount = displayAmount(value, decimal);
    return properAmount;
  };

  const getSendingAddress = (address: string): string => {
    if (!address) return "";
    const [notJSON, json] = jsonParse(address);
    if (notJSON) return address.length ? address : "";
    return json.join("\n");
  };

  const formatValue = (amount: string | undefined, value: any) =>
    amount ? value : "";

  return (
    <>
      <Tabs
        sx={{ borderBottom: "solid #E1E4EA 1px", marginBottom: "1rem" }}
        value={tabsIndex}
        onChange={handleTabChange}
      >
        {destinationTabs.map((item, index) => {
          const name = (
            <Box sx={{ display: "flex", gap: "0.2rem", alignItems: "center" }}>
              {t(item.name)}
              {item.countDom}
            </Box>
          );

          return <Tab key={index} label={name} {...a11yProps(index)} />;
        })}
      </Tabs>
      {destinationTabs.map((item, index) => {
        return (
          <TabPanel key={index} value={tabsIndex} index={index}>
            <section className={style.beforeAfterTextContainer}>
              <div className={style.beforeEdit}>{t("before_amt")}</div>
              <div className={style.afterEdit}>{t("after_amt")}</div>
            </section>
            {item.arr?.map((regulationItem, index) => (
              <section
                id="gridContainerSection"
                key={regulationItem.id}
                className={style.recordsWatchRegulation}
              >
                <div>{t("amountIslargerThan")}</div>
                <div>
                  {formatValue(
                    regulationItem.existing_amount,
                    getProperValues(regulationItem.existing_amount!),
                  )}
                </div>
                <div>
                  {formatValue(
                    regulationItem.amount,
                    getProperValues(regulationItem.amount),
                  )}
                </div>
                <div>{t("noOfApprover")}</div>
                <div>
                  {formatValue(
                    regulationItem.existing_amount,
                    regulationItem.existing_approver_no!,
                  )}
                </div>
                <div>
                  {formatValue(
                    regulationItem.amount,
                    regulationItem.approver_no,
                  )}
                </div>
                {item.name !== "internal_withdraw" && (
                  <>
                    <div>{t("sending_address")}</div>
                    <div style={{ overflowWrap: "anywhere", lineHeight: 1.5 }}>
                      {formatValue(
                        regulationItem.existing_amount,
                        getSendingAddress(
                          regulationItem.existing_sending_address!,
                        ),
                      )}
                    </div>
                    <div style={{ overflowWrap: "anywhere", lineHeight: 1.5 }}>
                      {formatValue(
                        regulationItem.amount,
                        getSendingAddress(regulationItem.sending_address!),
                      )}
                    </div>
                  </>
                )}
              </section>
            ))}
          </TabPanel>
        );
      })}
    </>
  );
};

/*    <section key={item.id} className={style.recordWatchRegulation}>
                <div style={{ alignSelf: "center", fontSize: "13px" }}>
                  <div style={{ gridArea: "no", textAlign: "center" }}>
                    {item.seq + 1}
                  </div>
                </div>
                <section
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    justifySelf: "center",
                  }}
                >
                  <div>
                    <div
                      style={{
                        gridArea: "type",
                        fontSize: "12px",
                      }}
                    >
                      {t("withdraw")}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        gridArea: "type",
                        fontSize: "12px",
                      }}
                    >

                      {t("settlement")}
                    </div>
                  </div>
                </section>
                <section>
                  <div style={{ marginRight: "2.5px" }}>
                    <MpTextField
                      InputLabelProps={{ shrink: true }}
                      name={"amountBeforeEdit"}
                      variant="filled"
                      defaultValue={getProperValues(
                        item.withdraw_existing_amt!
                      )}
                      sx={{ gridArea: "amtBefore", width: "100%" }}
                      label={t("existing_amount")}
                      disabled={true}
                    />
                  </div>
                  <div style={{ marginRight: "2.5px" }}>
                    <MpTextField
                      InputLabelProps={{ shrink: true }}
                      name={"amountBeforeEdit"}
                      variant="filled"
                      defaultValue={getProperValues(item.settle_existing_amt!)}
                      sx={{ gridArea: "amtBefore", width: "100%" }}
                      label={t("existing_amount")}
                      disabled={true}
                    />
                  </div>
                </section>

                <section>
                  <div style={{ marginLeft: "2.5px" }}>
                    <MpTextField
                      InputLabelProps={{ shrink: true }}
                      name={"requestEditAmount"}
                      variant="filled"
                      defaultValue={getProperValues(item.withdraw_request_amt)}
                      sx={{ gridArea: "amtAfter", width: "100%" }}
                      label={t("edited_amount")}
                      disabled={true}
                    />
                  </div>
                  <div style={{ marginLeft: "2.5px" }}>
                    <MpTextField
                      InputLabelProps={{ shrink: true }}
                      name={"requestEditAmount"}
                      variant="filled"
                      defaultValue={getProperValues(item.settle_request_amt)}
                      sx={{ gridArea: "amtAfter", width: "100%" }}
                      label={t("edited_amount")}
                      disabled={true}
                    />
                  </div>
                </section>
              </section> */
